import jsPDF from "jspdf";

import bnr_logo from "../../assets/images/BNRathiLogo.png";
import sebi_logo from "../../assets/images/SebiImg.png";
import autoTable from "jspdf-autotable";

const exportToPDF_Annexure = (annexureDetailsData, tableDataPdf, ruleData, currentDatePdf) => {
  const doc = new jsPDF();

  const pageWidth = doc.internal.pageSize.width;
  const pageHeight = doc.internal.pageSize.height;
  const marginLeft = 10;
  const marginRight = 10;
  const marginTop = 70;
  const marginBottom = 30;
  const colWidth = (pageWidth - marginLeft - marginRight) / 2;

  const textBlockWidth = 100; // fixed width for center block
  const centerX = pageWidth / 2;
  const textBlockStartX = centerX - textBlockWidth / 2;

  const header = () => {
    const imgWidthLeft = 25;
    const imgHeightLeft = 30;
    const imgWidthRight = 25;
    const imgHeightRight = 30;
    const imageY = 10;

    const centerX = pageWidth / 2;
    const textBlockWidth =
      pageWidth - imgWidthLeft - imgWidthRight - 2 * marginLeft - 20;
    const lineGap = 3; // vertical gap between lines of same block
    const blockGap = 3; // vertical gap between different text blocks
    let currentY = imageY + 4;

    // === Draw Images ===
    doc.addImage(
      bnr_logo,
      "PNG",
      marginLeft,
      imageY,
      imgWidthLeft,
      imgHeightLeft
    );
    doc.addImage(
      sebi_logo,
      "PNG",
      pageWidth - marginRight - imgWidthRight,
      imageY,
      imgWidthRight,
      imgHeightRight
    );

    // === Helper: Draw multi-line centered text ===
    const drawWrappedText = (text, fontSize = 10, bold = false) => {
      doc.setFont("helvetica", bold ? "bold" : "normal");
      doc.setFontSize(fontSize);

      const lines = doc.splitTextToSize(text, textBlockWidth);
      lines.forEach((line) => {
        doc.text(line, centerX, currentY, { align: "center" });
        currentY += lineGap;
      });
      currentY += blockGap;
    };

    // === Draw Text Blocks ===
    drawWrappedText("B N RATHI SECURITIES LIMITED", 11, true);
    drawWrappedText(
      "6-3-652, 4TH FLOOR KAUTILYA AMRUTHA ESTATES SOMAJIGUDA HYDERABAD-500082, 40527777-40727777"
    );
    drawWrappedText(
      `GST No: 12ABCDE1234FZ1   PAN No: AABCB6140Q   CIN No: L65993TG1985PLC005838`
    );
    drawWrappedText("Annexure I FORM NO : 10DB (See Rule 20AB)", 11, true);

    // === Bottom Border ===
    doc.setDrawColor(0);
    doc.setLineWidth(0.5);
    doc.line(marginLeft, currentY, pageWidth - marginRight, currentY);
  };

  // Call header
  header();

  const leftDetails = [
    {
      label: "Name of Assessee:",
      value: annexureDetailsData?.assential_details?.name,
    },
    {
      label: "Address:",
      value: annexureDetailsData?.assential_details?.address,
    },
  ];

  const rightDetails = [
    { label: "MAPIN of the Assessee:", value: "" },
    {
      label: "PAN No of the Assessee:",
      value: annexureDetailsData?.assential_details?.pan,
    },
    { label: "GST.Reg.No :", value: "" },
    { label: "Stock Exchange:", value: "National Stock Exchange" },
    {
      label: "Financial Year:",
      value: annexureDetailsData?.assential_details?.financial_year,
    },
    { label: "Broker Member ID:", value: "07141" },
  ];

  // Call after header

  const drawTwoColumnDetailBlock = (
    leftData = [],
    rightData = [],
    startY = 60,
    leftX = marginLeft,
    rightX = pageWidth / 2 + 25,
    labelFontSize = 7,
    lineHeight = 4
  ) => {
    doc.setFontSize(labelFontSize);
    doc.setFont("helvetica", "normal");

    const leftBlockWidth = pageWidth / 2 - 40;
    const rightBlockWidth = pageWidth / 2 - 40;

    let leftCurrentY = startY;
    let rightCurrentY = startY;

    // Process left column independently
    leftData.forEach((item) => {
      const leftText = `${item.label || ""} ${item.value || ""}`.trim();
      const leftLines = doc.splitTextToSize(leftText, leftBlockWidth);

      leftLines.forEach((line, index) => {
        doc.text(line, leftX, leftCurrentY + index * lineHeight);
      });

      leftCurrentY += leftLines.length * lineHeight; // Gap between items
    });

    // Process right column independently
    rightData.forEach((item) => {
      const rightText = `${item.label || ""} ${item.value || ""}`.trim();
      const rightLines = doc.splitTextToSize(rightText, rightBlockWidth);

      rightLines.forEach((line, index) => {
        doc.text(line, rightX, rightCurrentY + index * lineHeight);
      });

      rightCurrentY += rightLines.length * lineHeight; // Gap between items
    });

    // Return the maximum Y position reached by either column
    return Math.max(leftCurrentY, rightCurrentY);
  };

  const detailBlockY = drawTwoColumnDetailBlock(leftDetails, rightDetails, 55);
  const additionalLeftDetails = [
    { label: "Name of Stock Brokers:", value: "B N RATHI SECURITIES LIMITED" },
    {
      label: "Address:",
      value:
        "6-3-652, 4TH FLOOR KAUTILYA AMRUTHA ESTATES SOMAJIGUDA HYDERABAD-500082",
    },
  ];

  // Simple block rendering
  const drawSingleLeftBlock = (
    data = [],
    startY,
    leftX = marginLeft,
    labelFontSize = 7,
    lineHeight = 4
  ) => {
    const blockWidth = pageWidth / 2 - 40;
    let currentY = startY;

    doc.setFontSize(labelFontSize);
    doc.setFont("helvetica", "normal");

    const leftBlockWidth = pageWidth / 2 - 40;

    let leftCurrentY = startY;

    // Process left column independently
    data.forEach((item) => {
      const leftText = `${item.label || ""} ${item.value || ""}`.trim();
      const leftLines = doc.splitTextToSize(leftText, leftBlockWidth);

      leftLines.forEach((line, index) => {
        doc.text(line, leftX, leftCurrentY + index * lineHeight);
      });

      leftCurrentY += leftLines.length * lineHeight; // Gap between items
    });

    return leftCurrentY;
  };

  //  Call after detailBlockY
  const bottomY = drawSingleLeftBlock(additionalLeftDetails, detailBlockY + 5);

  // === Bottom Border ===
  doc.setDrawColor(0);
  doc.setLineWidth(0.3);
  doc.line(marginLeft, bottomY, pageWidth - marginRight, bottomY);

  // table data
  // Table configuration
  // Table configuration
  const columns = [
    { header: "Client Code Number (1)", dataKey: "client_code" },
    { header: "Code of Transaction (2)", dataKey: "index" },
    { header: "Value of Transaction Entered into during the Financial Year. (3)", dataKey: "values_1" },
    { header: "Total Security Transaction Tax Collected from the Assessee During the Financial Year. (4)", dataKey: "values_2" },
    { header: "Value of Transaction ( Include in Value Given in Column 3) Entered into the course of business by the Assessee. (5)", dataKey: "empty1" },
    { header: "Total Securities Transaction Tax Collected on Value of Transactions given in Column 5. (6)", dataKey: "empty2" },
  ];

  // Prepare table data from the object structure
  const tableRows =
    tableDataPdf?.values_1?.map((value1, rowIdx) => ({
      client_code: rowIdx === 0 ? tableDataPdf.client_code : "", // Show client code only in first row
      index: (rowIdx + 1).toString().padStart(2, "0"),
      values_1: new Intl.NumberFormat("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(Number(value1) || 0),
      values_2: new Intl.NumberFormat("en-IN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(Number(tableDataPdf.values_2[rowIdx]) || 0),
      empty1: "",
      empty2: "",
    })) || [];

  // Add table with footer

  doc.setFontSize(10);
doc.setFont("helvetica", "bold");
doc.text("Details of Value of Securities Transactions and Transaction Tax Collected from the Assessee.", 30, bottomY +4); 
const lineY = bottomY +5; // 3 units below the heading text
doc.setLineWidth(0.3);
doc.line(marginLeft, lineY, doc.internal.pageSize.width - marginRight, lineY);
autoTable(doc, {
  columns: columns,
  body: tableRows,
  startY: bottomY + 8, 
  margin: { left: marginLeft, right: marginRight }, 
  styles: {
    fontSize: 7,
    cellPadding: 0,
    fillColor: null,
    alternateRowStyles: {
      fillColor: null,
    },
  },
  headStyles: {
    fillColor: null, 
    textColor: 0, 
    fontStyle: "normal",
    halign: "center",
    lineWidth: { bottom: .3 }, 
  lineColor: 0,
  },
  bodyStyles: {
    fillColor: null, // No background for body
    textColor: 0, // Black text for body
    halign: "center",
    cellPadding: {top: 1, bottom: 1}, 
    lineWidth: 0,
    alternateRowStyles: {
      fillColor: null, // No alternate background for body
      textColor: 0, // Black text for alternate rows
    },
  },
  columnStyles: {
    0: { halign: "left", fillColor: null, cellWidth: 30  },
    1: { halign: "center", fillColor: null, cellWidth: 30  },
    
    2: { fillColor: null, cellWidth: 30  },
    3: { fillColor: null, cellWidth: 30  },
    4: { fillColor: null, cellWidth: 30  },
    5: { fillColor: null, cellWidth: 30  },
  },
  foot: [
    [
      {
        content: "* Total",
        colSpan: 2,
        styles: {
          halign: "right",
          fontStyle: "normal",
          fillColor: null, // Remove background color
          
        },
      },
      {
        content: Number(tableDataPdf?.total_values_1 ?? 0).toLocaleString(
          "en-IN",
          {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }
        ),
        styles: {
          halign: "center",
          fontStyle: "normal",
          fillColor: null, // Remove background color
        },
      },
      {
        content: Number(tableDataPdf?.total_values_2 ?? 0).toLocaleString(
          "en-IN",
          {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }
        ),
        styles: {
          halign: "center",
          fontStyle: "normal",
          fillColor: null, // Remove background color
        },
      },
      { 
        content: "", 
        styles: { 
          fillColor: null // Remove background color
        } 
      },
      { 
        content: "", 
        styles: { 
          fillColor: null // Remove background color
        } 
      },
    ],
  ],
  footStyles: {
    fillColor: null, // Explicitly remove footer background color
    textColor: 0, // Black text
    fontStyle: "normal",
    lineWidth: { bottom: 0.3, top:0.3 }, 
    lineColor: 0,
    cellPadding: {top: 1, bottom: 1}, 
  },
});
  const finalY = doc.lastAutoTable.finalY;

  // Add heading
  doc.setFontSize(7);
  doc.setFont("helvetica", "bold");
  doc.text("Verification", marginLeft, finalY + 4);
  
  // Add text with underlines
  const textArray = [
    "I,___________________________son|daughter of ___________________solemnly declare that to the best of my knowledge and belief the information given in this Form in correct and complete and that the total amount of securities transaction tax shown therein is truly stated and is in accordance with the provisions of Chapter VII of the Finance (No.2) Act, 2004 and SecuritiesTransaction Tax Rules, 2004."
  ];
  
  doc.setFontSize(7);
  doc.setFont("helvetica", "normal");
  let currentY = finalY + 8;
  
  const textWidth = pageWidth - marginLeft - 20; // Available width for text

  textArray.forEach((text, index) => {
    const wrappedText = doc.splitTextToSize(text, textWidth);
    wrappedText.forEach((line, lineIndex) => {
      doc.text(line, marginLeft, currentY);
      currentY += 5; // Line spacing
    });
    currentY += 1; // Extra spacing between paragraphs
  });
  currentY += 5; // Extra spacing before date/place

// Left side - Date and Place
doc.text("Place: HYDERABAD", marginLeft, currentY);
doc.text(`Date: ${currentDatePdf}`, marginLeft, currentY +5);

// Right side - Name field
const rightX = pageWidth / 2 + 40;
doc.text("(Name and Signature of Assessee)", rightX, currentY + 6);

doc.setFontSize(9);
doc.setFont("helvetica", "bold");
doc.text("Codes in Respect of Taxable Securities Transaction", 60, currentY + 10);

// Add rule data table without borders
const ruleColumns = [
  { header: "S.No", dataKey: "sno" },
  { header: "Nature of Transaction Code", dataKey: "particulars" },
];

const ruleRows = ruleData.map(item => ({
  sno: item.sno,
  particulars: item.particulars,
}));

autoTable(doc, {
  columns: ruleColumns,
  body: ruleRows,
  startY: currentY + 12,
  styles: {
    fontSize: 7,
    cellPadding: 1,
    fillColor: null,
    lineWidth: 0, // No border
  },
  headStyles: {
    fillColor: null,
    textColor: [0, 0, 0], // Black text
    fontStyle: 'bold',
    lineWidth: 0,
  },
  bodyStyles: {
    fillColor: null,
    textColor: [0, 0, 0], // Black text
    halign: "right", // Right align for numbers
    alternateRowStyles: {
      fillColor: null, // Remove alternate row background color
    },
    lineWidth: 0,
  },
  columnStyles: {
    0: { halign: "left", fillColor: null }, 
    1: { halign: "left", fillColor: null }, 
  },
  theme: 'plain', // Plain theme without borders
  
});

  window.open(doc.output("bloburl"), "_blank");
};

export default exportToPDF_Annexure;
